import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import * as Sentry from '@sentry/vue'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    const token = store.getters.user.token
    const userType = store.getters.user.userType

    if (!token || !userType) {
      next({ name: 'login' })
    } else {
      if (to.meta.grants.includes(userType.id)) {
        next()
      } else {
        next({ name: 'ops' })
      }
    }
  } else {
    next()
  }
})

Sentry.init({
  Vue,
  dsn: 'https://6c0ac96acfff9b32cb318720134e7dfd@o4507741824221184.ingest.us.sentry.io/4507976471937024',
  // integrations: [
  //   Sentry.browserTracingIntegration({ router }),
  //   Sentry.replayIntegration()
  // ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/corretores\.idealizacidades\.com\.br/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Enabled in production environment
  enabled: process.env.NODE_ENV === 'production'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  template: '<App/>',
  store,
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js